var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCheckWhite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4408_20517)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25 4.85538C13.8744 4.85538 4.85537 13.8744 4.85537 25C4.85537 36.1256 13.8744 45.1446 25 45.1446C36.1256 45.1446 45.1446 36.1256 45.1446 25C45.1446 13.8744 36.1256 4.85538 25 4.85538ZM0.378784 25C0.378784 11.4021 11.4021 0.378792 25 0.378792C38.5979 0.378792 49.6212 11.4021 49.6212 25C49.6212 38.5979 38.5979 49.6212 25 49.6212C11.4021 49.6212 0.378784 38.5979 0.378784 25Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.85537 25C4.85537 13.8744 13.8744 4.85538 25 4.85538C36.1256 4.85538 45.1446 13.8744 45.1446 25C45.1446 36.1256 36.1256 45.1446 25 45.1446C13.8744 45.1446 4.85537 36.1256 4.85537 25Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.3038 17.1258C38.9005 17.7225 38.9005 18.69 38.3038 19.2866L21.4966 36.0939C20.8999 36.6905 19.9325 36.6905 19.3358 36.0939L11.6962 28.4542C11.0995 27.8575 11.0995 26.8901 11.6962 26.2934C12.2929 25.6967 13.2603 25.6967 13.857 26.2934L20.4162 32.8526L36.143 17.1258C36.7397 16.5291 37.7071 16.5291 38.3038 17.1258Z",
    fill: "#DD620D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4408_20517"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckWhite);
export default __webpack_public_path__ + "static/media/check-white.4c47ecbbc1f55d24c2dd4a0cd99d67be.svg";
export { ForwardRef as ReactComponent };